import { render, staticRenderFns } from "./chooseFreeTake.vue?vue&type=template&id=7c25a1a8&scoped=true&"
import script from "./chooseFreeTake.vue?vue&type=script&lang=js&"
export * from "./chooseFreeTake.vue?vue&type=script&lang=js&"
import style0 from "./chooseFreeTake.vue?vue&type=style&index=0&id=7c25a1a8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c25a1a8",
  null
  
)

export default component.exports